<template>
  <article class="appCard">
    <header class="appCard-header">
      <h4 class="title">
        <slot name="header"></slot>
      </h4>
    </header>
    <section class="appCard-content">
      <slot name="content"></slot>
    </section>
    <footer class="appCard-footers">
      <slot name="footer"></slot>
    </footer>
  </article>
</template>

<script>
export default {
  name: "AppCard"
};
</script>

<style lang="scss" scoped>
.appCard {
  border: solid 1px #e0e0e0;
  &-header {
    border-bottom: solid 1px #e0e0e0;
    padding: 5px 10px;
    .title {
      margin-bottom: 0px !important;
      font-weight: 500 !important;
    }
  }
  &-content {
    padding: 10px;
  }
}
</style>

